module.exports = __webpack_public_path__ + "img/w3_maximize_list_white.ae88edd7.png";